import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';
import { PERMISSIONS, DEFAULT_KEY_PERMISSIONS, grantRate } from './permissionMeta';

/**
 * Per-permission grant-rate comparison — grouped bars, Android vs iOS grant %,
 * derived from the same per-platform counts as the summary panels (no extra
 * fetch). Snapshot data → a categorical bar comparison (NOT a time-series line).
 *
 * Props: { counts, summary, selected }
 */
const shortLabel = (key) => ((PERMISSIONS.find((p) => p.key === key) || {}).label || key).replace(/ \(.*\)$/, '');

const PermissionGrantRateChart = ({ counts, summary, selected }) => {
  const c = counts || {};
  const s = summary || {};
  const keys = selected && selected.length ? selected : DEFAULT_KEY_PERMISSIONS;
  const androidUsers = Number(s.android_users) || 0;
  const iosUsers = Number(s.ios_users) || 0;
  const hasUsers = androidUsers > 0 || iosUsers > 0;

  const data = keys.map((key) => ({
    name: shortLabel(key),
    Android: grantRate(c[`android_${key}_count`], androidUsers),
    iOS: grantRate(c[`ios_${key}_count`], iosUsers),
  }));

  return (
    <div className="au-panel up-chart" data-testid="up-chart">
      <div className="au-panel__head">
        <h4 className="au-panel__title">Grant rate by permission · Android vs iOS</h4>
        <span className="au-spacer" />
        <div className="au-legend">
          <span><i className="au-dot--android" style={{ background: '#2e9b87' }} />Android</span>
          <span><i className="au-dot--ios" style={{ background: '#f26b45' }} />iOS</span>
        </div>
      </div>

      {hasUsers ? (
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 4 }}>
            <CartesianGrid stroke="#eef2f1" vertical={false} />
            <XAxis dataKey="name" tick={{ fontSize: 11, fill: '#94a3b8' }} interval={0} angle={-15} textAnchor="end" height={60} />
            <YAxis width={44} tick={{ fontSize: 11, fill: '#94a3b8' }} unit="%" domain={[0, 100]} />
            <Tooltip formatter={(value, name) => [`${value}%`, name]} />
            <Legend />
            <Bar dataKey="Android" name="Android" fill="#2e9b87" radius={[3, 3, 0, 0]} />
            <Bar dataKey="iOS" name="iOS" fill="#f26b45" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="au-chart-empty" data-testid="up-chart-empty">
          No users to compute grant rates for the current view.
        </div>
      )}
    </div>
  );
};

export default PermissionGrantRateChart;
